import React, { useEffect, useState } from 'react';
import imgTurnike from '../assets/login-hero/turnike.jpg';
import imgMetro from '../assets/login-hero/metro-turnike.jpg';
import imgReader from '../assets/login-hero/kart-okuyucu.jpg';
import imgQr from '../assets/login-hero/qr-telefon.jpg';

const SLIDES = [
    {
        image: imgTurnike,
        title: 'Turnikeden güvenle geçin.',
        text: 'Personel yaklaşır, geçiş kaydı anında düşer.',
    },
    {
        image: imgMetro,
        title: 'QR ile anında giriş.',
        text: 'Telefonunuzdaki kodu okutun, turnike açılsın.',
    },
    {
        image: imgReader,
        title: 'Cihazdan okutun.',
        text: 'Kart, NFC veya BLE ile kapı okuyucusuna yaklaşmanız yeterli.',
    },
    {
        image: imgQr,
        title: 'Mobil kimlik cebinizde.',
        text: 'QR veya telefonla geçiş; kart unutmak artık sorun değil.',
    },
];

export default function LoginBrandStage() {
    const [scene, setScene] = useState(0);

    useEffect(() => {
        const t = setInterval(() => setScene((s) => (s + 1) % SLIDES.length), 6500);
        return () => clearInterval(t);
    }, []);

    const current = SLIDES[scene];

    return (
        <aside className="xpass-hero hidden lg:block lg:w-2/3">
            {SLIDES.map((slide, i) => (
                <img
                    key={slide.title}
                    className={`xpass-hero-photo ${i === scene ? 'is-on' : ''}`}
                    src={slide.image}
                    alt=""
                />
            ))}

            <div className="xpass-hero-overlay" />
            <div className="xpass-hero-sweep" />
            <div className="xpass-hero-leak xpass-hero-leak-a" />
            <div className="xpass-hero-leak xpass-hero-leak-b" />
            <div className="xpass-hero-grain" />

            <div className="xpass-hero-copy" key={scene}>
                <p className="xpass-hero-kicker">XPass PDKS</p>
                <h2>{current.title}</h2>
                <span className="xpass-hero-rule" />
                <p className="xpass-hero-sub">{current.text}</p>
            </div>

            <div className="xpass-hero-dots">
                {SLIDES.map((slide, i) => (
                    <button
                        key={slide.title}
                        type="button"
                        className={i === scene ? 'is-on' : ''}
                        onClick={() => setScene(i)}
                        aria-label={slide.title}
                    />
                ))}
            </div>
        </aside>
    );
}
